
import multiBatchFilter from '../commonFilter/commonFilterModule';
import template from './views/edituser.html';
const name = 'editUser';
class EditUser {

    constructor($scope,  $state,  $compile, $element, authService, localStorageService, $rootScope) {
        'ngInject';
        var ctrl = this;
        let self = this;

        $scope.showRolesList = true
        $scope.showAcademicFilters = true
        $scope.Users = [];
        $scope.isparent = false;
        $scope.keys = [];
        $scope.stateId = 'edituser';
        $scope.userFilter = {};
        $scope.loading = false
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            $rootScope.title = "Edit User"
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }
        this.$onDestroy = () => {
            $scope.Users = []
        }

        $scope.clearParentFields = function() {
            // clearArrayFields();
            $scope.Users = [];
        }


        $scope.searchValuesBasedOnFilter = function() {

            if (this.filterObj === undefined || this.filterObj.role_id === undefined) {
                toastr.error('Please Select the Role')
                return false;
            } else if ((this.filterObj.role_id === 'student') && (this.filterObj === undefined || this.filterObj['session'] === undefined)) {
                toastr.error('Please Select the Session')
                return false;
            } else if ((this.filterObj.role_id === 'student') && (this.filterObj === undefined || this.filterObj['curriculum'] === undefined)) {
                toastr.error('Please Select the Curriculum')
                return false;
            } else if ((this.filterObj.role_id === 'student') && (this.filterObj === undefined || this.filterObj['xclass'] === undefined || this.filterObj['xclass'].length <= 0)) {
                toastr.error('Please Select the Class')
                return false;
            } else if ((this.filterObj.role_id === 'student') && (this.filterObj === undefined || this.filterObj['batch'] === undefined || this.filterObj['batch'].length <= 0)) {
                toastr.error('Please Select the Batch')
                return false;
            }
            console.log(this.filterObj)
            callServerToGetusers(this.filterObj)
        }


        var schoolIdLocal = localStorageService.get('school_id')
        function callServerToGetusers(filters) {
            $scope.userFilter = filters;
            let obj = {
                userMgt : filters,
                school_id : schoolIdLocal
            }
            authService.callAPI("/v0/edit_user/getAllUserBasicDetails", "POST", 
                {args : obj}, function (response) {
                if(!response.error){
                    let result = response.result.data.details.response
                    if (result.users.length > 0) {
                        $scope.Users = [];
                        $scope.Users = result.users;
                        $scope.Users.sort(function(a, b) {
                            var textA = a.name.toUpperCase();
                            var textB = b.name.toUpperCase();
                            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                        });
                        $scope.isparent = result.isparent;
                        
                    } else {
                        toastr.success('No records found')
                    }
                    _.defer(function() { $scope.$apply(); });;
                }else{
                    console.log('error')
                }
            })
            // Meteor.call("getAllUserBasicDetails", filters, Session.get('school_id'), function(error, result) {
            //     if (error) {
            //         console.log('error')
            //     } else {
            //         console.log(result)
            //         if (result.users.length > 0) {
            //             $scope.Users = [];
            //             $scope.Users = result.users;
            //             $scope.Users.sort(function(a, b) {
            //                 var textA = a.name.toUpperCase();
            //                 var textB = b.name.toUpperCase();
            //                 return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            //             });
            //             $scope.isparent = result.isparent;
            //             _.defer(function() { $scope.$apply(); });;
            //         } else {
            //             toastr.success('No records found')
            //         }


            //     }
            // })
        }
        function _checkAllValuesInMotherObj(arr){
            let len = arr.length
            let motherKvs = {
                mother_name : {
                    other_keys : ['mother_mobile', 'mother_email'],
                    error_key : "name"
                },
                mother_mobile : {
                    other_keys : ['mother_email', 'mother_name'],
                    error_key : "phone"
                },
                mother_email : {
                    other_keys : ['mother_mobile', 'mother_name'],
                    error_key : "email"
                }
            }
            let keys = Object.keys(motherKvs)
            let str = '_error'
            let array = []
            for(let i = 0; i < len; i++){
                let item = arr[i]
                if (item.mother_obj){
                    for(let k = 0; k < keys.length; k++){
                        item.mother_obj[motherKvs[keys[k]]['error_key'] + str] = ''
                    }
                    let  err = 0
                    for(let k = 0; k < keys.length; k++){
                        if(item.mother_obj[keys[k]]){
                            let otherKeys = motherKvs[keys[k]].other_keys
                            for(let o = 0; o < otherKeys.length; o++){
                                if(!item.mother_obj[otherKeys[o]]){
                                    err++
                                    item.mother_obj[motherKvs[otherKeys[o]].error_key + str] = motherKvs[otherKeys[o]].error_key + " is required"
                                }
                            }
                        }
                    }
                    if(err){
                        array.push(item)
                    }else{
                        if(item.mother_obj.mother_email){
                            if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(item.mother_obj.mother_email)){
                            }else{
                                item.mother_obj['email' + str] = "Please enter valid email"
                                array.push(item)
                            }
                        }
                    }
                }
            }
            return array.length
        }
        function _checkMotherPhoneAndEmail(arr){
            let _duArray = []
            arr.forEach(function(item) {
                if (item.mother_obj) {
                    item.mother_obj.phone_error = ''
                    if(item.mother_obj.mother_mobile){
                        let len = item.mother_obj.mother_mobile.length
                        if(len < 8 || len > 18){
                            item.mother_obj.phone_error = "Phone number should be greater than 8 and less than 18"
                            _duArray.push(item)
                        }
                    }
                    if(item.mother_obj.mother_email){
                        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(item.mother_obj.mother_email)){
                        }else{
                            item.mother_obj['email_error'] = "Please enter valid email"
                            _duArray.push(item)
                        }
                    }
                }
            })
            return _duArray.length
        }
        $scope.updateUsers = function() {

            if ($scope.userFilter["role_id"] === 'student') {
                console.log('jjjjjjjjjjjjjj')
                let empErrorlength = findDuplicateArrayValue($scope.Users, "admission_number", "employee_no_error")
                let nameErrorlength = findUndefinedArrayValue($scope.Users, "name", "name_error")
                let userNameErrorlength = findDuplicateArrayValue($scope.Users, "username", "username_error")
                    // let phoneErrorlength = findUndefinedArrayValue($scope.Users, "phone", "phone_error")
                let parentEmailErrorlength = findUndefinedArrayValue($scope.Users, "parent_email", "parent_email_error")
                let parentnameErrorlength = findUndefinedArrayValue($scope.Users, "parent_name", "parentname_error")
                let parentnameErrolength = findDuplicateDifferentkayValue($scope.Users, "parent_email", "username", "parent_email_error")
                let motherphoneErrors = _checkMotherPhoneAndEmail($scope.Users)
                // let  = empErrorlength + userNameErrorlength + nameErrorlength + parentEmailErrorlength + parentnameErrorlength + motherphoneErrors
                
                if ((empErrorlength + userNameErrorlength + nameErrorlength + parentEmailErrorlength + parentnameErrorlength + motherphoneErrors) === 0) {
                    // let error = _checkAllValuesInMotherObj($scope.Users)
                    callServerToUpdate("updateStudentDetails")
                } else {
                    return false;
                }

            } else {

                if ($scope.isparent) {
                    let userNameErrorlength = findDuplicateArrayValue($scope.Users, "username", "username_error")
                        // let phoneErrorlength = findDuplicateArrayValue($scope.Users, "phone", "phone_error")
                    let nameErrorlength = findUndefinedArrayValue($scope.Users, "name", "name_error")

                    if ((userNameErrorlength + nameErrorlength) === 0) {
                        callServerToUpdate("updateParentDetailsToUpdate")
                    } else {
                        return false;
                    }
                } else {
                    let empErrorlength = findDuplicateArrayValue($scope.Users, "employee_no", "employee_no_error")
                    let userNameErrorlength = findDuplicateArrayValue($scope.Users, "username", "username_error")
                        // let phoneErrorlength = findDuplicateArrayValue($scope.Users, "phone", "phone_error")
                    let nameErrorlength = findUndefinedArrayValue($scope.Users, "name", "name_error")

                    if ((empErrorlength + userNameErrorlength + nameErrorlength) === 0) {
                        callServerToUpdate("updateEmployeeDetails")
                    } else {
                        return false;
                    }
                }

            }
        }

        function callServerToUpdate(methodname) {
            let obj = {
                users : $scope.Users,
                school_id : schoolIdLocal
            }
            $scope.loading = true
            authService.callAPI("/v0/edit_user/"+methodname, "POST", 
                {args : obj}, function (response) {
                    $scope.loading = false
                if(!response.error){
                    let result = response.result.data.details.response
                    console.log(result)
                    $scope.Users = result;
                    if (result != undefined && result.length > 0) {
                        toastr.error('Some values not updated');
                    } else {
                        toastr.success('Updated successfully')
                    }
                    _.defer(function() { $scope.$apply(); });;
                }else{
                    console.log('error')
                }
            })
            // Meteor.call(methodname, $scope.Users, Session.get('school_id'), function(error, result) {
            //     if (error) {
            //         console.log('error')
            //     } else {

            //         $scope.Users = result;
            //         if (result != undefined && result.length > 0) {
            //             toastr.error('Some values not updated');
            //         } else {
            //             toastr.success('Updated successfully')
            //         }
            //         _.defer(function() { $scope.$apply(); });;

            //     }
            // })
        }

        function findUndefinedArrayValue(arr, key, errorkey) {
            var _unArray = [];
            var _duArray = [];
            arr.forEach(function(item) {
                if (item[key] === undefined || item[key] === "" || item[key] === null) {
                    item[errorkey] = "please enter the value"
                    _duArray.push(item)
                }
            })
            return _duArray.length
        }

        function findDuplicateArrayValue(arr, key, errorkey) {
            var _unArray = [];
            var _duArray = [];
            arr.forEach(function(item) {
                if (item[key] === undefined || item[key] === "" || item[key] === null) {
                    item[errorkey] = "please enter the value"
                    _duArray.push(item)
                } else {
                    var isPresent = _unArray.filter(function(elem) {
                        return elem[key] === item[key]
                    })

                    if (isPresent.length > 0) {
                        item[errorkey] = "This Value is available at index : " + isPresent[0].index
                        _duArray.push(item)
                    } else {
                        delete item[errorkey];
                        _unArray.push(item)
                    }
                }
            })
            return _duArray.length
        }

        function findDuplicateDifferentkayValue(arr, key, altKey, errorkey) {
            var _unArray = [];
            var _duArray = [];
            arr.forEach(function(item) {

                var isPresent = _unArray.filter(function(elem) {
                    return elem[key] === item[altKey]
                })

                if (isPresent.length > 0) {
                    item[errorkey] = "This Value is available at index : " + isPresent[0].index
                    _duArray.push(item)
                } else {
                    delete item[errorkey];
                    _unArray.push(item)
                }

            })
            return _duArray.length
        }

        function csvCovertor(jsonData, reportTitle, showLabel) {
            //If JSONData is not an object then JSON.parse will parse the JSON string in an Object
            var arrData = typeof jsonData != 'object' ? JSON.parse(jsonData) : jsonData;
            var csv = '';
            //Set Report title in first row or line
            // csv += reportTitle + '\r\n\n';
            //This condition will generate the Label/Header
            if (showLabel) {
                var row = "";
                //This loop will extract the label from 1st index of on array
                _.each($scope.header, function(header) {
                    row += header + ',';
                })
                row = row.slice(0, -1);
                //append Label row with line break
                csv += row + '\r\n';
            }

            _.each(arrData, function(data) {
                let row = "";
                _.each($scope.keys, function(key) {
                    if (key === "address") {
                        row += '"' + ((data.addrLine1 ? data.addrLine1.replace(/['"]+/g, '') : '') +
                            (data.addrLine1 ? ', ' : '') + (data.addrLine2 ? data.addrLine2.replace(/['"]+/g, '') : '') +
                            (data.addrLine2 ? ', ' : '') + (data.city ? data.city.replace(/['"]+/g, '') : '') +
                            (data.city ? ', ' : '') + (data.country ? data.country.replace(/['"]+/g, '') : '') +
                            (data.country ? ', ' : '') + (data.pincode ? data.pincode.replace(/['"]+/g, '') : '')) + '",';
                    } else {
                        row += '"' + data[key] + '",';
                    }
                })
                row.slice(0, row.length - 1);
                //add a line break after each row
                csv += row + '\r\n';
            })

            if (csv == '') {
                alert("Invalid data");
                return;
            }
            //Generate a file name
            var fileName = "Report_";
            //this will remove the blank-spaces from the title and replace it with an underscore
            fileName += reportTitle.replace(/ /g, "_");

            //Initialize file format you want csv or xls
            var uri = 'data:text/csv;charset=utf-8,' + escape(csv);

            //this trick will generate a temp <a /> tag
            var link = document.createElement("a");
            link.href = uri;

            //set the visibility hidden so it will not effect on your web-layout
            link.style = "visibility:hidden";
            link.download = fileName + ".csv";

            //this part will append the anchor tag and remove it after automatic click
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }

        $scope.exportAsCSV = function() {

            $scope.keys = []
            $scope.header = []

            if ($scope.userFilter["role_id"] === 'student') {

                $scope.header.push("Academic Details")
                $scope.header.push("Admission No")
                $scope.header.push("Name")
                $scope.header.push("Email")
                $scope.header.push("Phone No")
                $scope.header.push("Address")
                $scope.header.push("Parent Email")
                $scope.header.push("parent name")
                $scope.header.push("Status")
                $scope.header.push("Mapped")

                $scope.keys.push("academicDetails")
                $scope.keys.push("admission_number")
                $scope.keys.push("name")
                $scope.keys.push("username")
                $scope.keys.push("phone")
                $scope.keys.push("address")
                $scope.keys.push("parent_email")
                $scope.keys.push("parent_name")
                $scope.keys.push("mapped")
                $scope.keys.push("mappedStudent")
            } else {

                $scope.header.push("Employee No")
                $scope.header.push("Name")
                $scope.header.push("Email")
                $scope.header.push("Phone No")
                $scope.header.push("Address")


                $scope.keys.push("employee_no")
                $scope.keys.push("name")
                $scope.keys.push("username")
                $scope.keys.push("phone")
                $scope.keys.push("address")
            }

            csvCovertor($scope.Users, "Record", true);
        }


    }
}

export default angular.module(name, [
    ])
    .component(name, {
        template: template,
        controller: ['$scope',  '$state', '$compile', '$element', 
        'authService', 'localStorageService', EditUser]
    })
    .controller('editUser', EditUser);


// function config($stateProvider) {
//     'ngInject';
//     $stateProvider.state('editUser', {
//         url: '/edit-user',
//         template: '<edit-user></edit-user>'
//     });
// }


// WEBPACK FOOTER //
// ./src/app/edit_user/edituserModule.js